module.exports = __webpack_public_path__ + "static/media/section05_02.200e150f.jpg";